module.exports = __webpack_public_path__ + "img/yesh_yes.4bf9aff0.png";